/* Archival redesign: homepage behaviours (scrollers with prev/next, category tabs). */
(function () {
  function initScroller(root) {
    if (root.__aaScroller) return;
    root.__aaScroller = true;
    var track = root.querySelector('[data-aa-track]');
    var prev = root.querySelector('[data-aa-prev]');
    var next = root.querySelector('[data-aa-next]');
    if (!track) return;
    function step() {
      var items = Array.prototype.filter.call(track.children, function (c) { return c.offsetWidth > 0; });
      if (!items.length) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return items[0].offsetWidth + gap;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    root.addEventListener('aa:refresh', function () { track.scrollLeft = 0; update(); });
    update();
  }

  function initTabs(root) {
    if (root.__aaTabs) return;
    root.__aaTabs = true;
    var radios = Array.prototype.slice.call(root.querySelectorAll('[role="radio"]'));
    var tiles = root.querySelectorAll('[data-aa-tab]');
    function select(radio, focus) {
      radios.forEach(function (r) {
        var on = r === radio;
        r.setAttribute('aria-checked', on ? 'true' : 'false');
        r.tabIndex = on ? 0 : -1;
      });
      Array.prototype.forEach.call(tiles, function (t) {
        t.hidden = t.getAttribute('data-aa-tab') !== radio.getAttribute('data-value');
      });
      if (focus) radio.focus();
      root.dispatchEvent(new CustomEvent('aa:refresh'));
    }
    radios.forEach(function (r, i) {
      r.addEventListener('click', function () { select(r, false); });
      r.addEventListener('keydown', function (e) {
        var d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (!d) return;
        e.preventDefault();
        select(radios[(i + d + radios.length) % radios.length], true);
      });
    });
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-aa-scroller]'), initScroller);
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-aa-tabs]'), initTabs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
